function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Energiebesparing-gas",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Energiebesparing-%-dit-jaar",
  transform: "translate(1.000000, 1.000000)",
  stroke: "#485156",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.1664,12.2 L24.1664,1.4 C24.1646002,1.0070838 23.9708104,0.639868805 23.6474562,0.416645975 C23.324102,0.193423146 22.9120371,0.142395286 22.544,0.28 L9.344,7.112 C8.87757388,7.28789549 8.56818805,7.73351293 8.5664,8.232 L8.5664,14.6",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 20.5664,
  y1: 7.4,
  x2: 24.1664,
  y2: 7.4,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 18.1664,
  y1: 12.2,
  x2: 24.1664,
  y2: 12.2,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.1664,
  y1: 19.4,
  x2: 3.7664,
  y2: 19.4,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.1664,
  y1: 24.2,
  x2: 6.1664,
  y2: 24.2,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.1664,
  y1: 5.6496,
  x2: 12.1664,
  y2: 0.2016,
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1664,36.2 L12.1664,17 C12.1664,15.6745166 11.0918834,14.6 9.7664,14.6 L2.5664,14.6 C1.2409166,14.6 0.1664,15.6745166 0.1664,17 L0.1664,36.2 L14.5664,36.2",
  id: "Path"
}))), /*#__PURE__*/React.createElement("g", {
  id: "match-fire-1-copy",
  transform: "translate(18.000000, 16.000000)",
  stroke: "#425CD4",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.91111111,14.6666667 C3.91111111,16.8267137 5.6621752,18.5777778 7.82222222,18.5777778 C9.98226924,18.5777778 11.7333333,16.8267137 11.7333333,14.6666667 C11.5981142,12.1095292 10.5584657,9.68368262 8.8,7.82222222 L6.84444444,12.7111111 L4.88888889,10.7555556 C4.30380535,11.9804347 3.97127466,13.3105575 3.91111111,14.6666667 L3.91111111,14.6666667 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,14.6666667 C0,18.9867607 3.50212818,22.4888889 7.82222222,22.4888889 C12.1423163,22.4888889 15.6444444,18.9867607 15.6444444,14.6666667 C15.6444444,6.84444444 8.8,0.977777778 8.8,0.977777778 L5.86666667,5.86666667 L3.91111111,3.91111111 C1.55689616,7.0221867 0.1940298,10.7700692 0,14.6666667 Z",
  id: "Path"
})));
function SvgEnergiebesparinggas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "40px",
    viewBox: "0 0 36 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Energiebesparing gas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergiebesparinggas);
export default __webpack_public_path__ + "static/media/Energiebesparing gas.4e6d1d624640d863bae32dcd5f0efc65.svg";
export { ForwardRef as ReactComponent };